import { Informer } from "@/@types/mails/informaers";
import { defineStore } from "pinia";
import { _GettersTree, _ActionsTree, StoreDefinition } from "pinia";

interface IInformer {
  informers: Informer[];
}

const state = (): IInformer => ({
  informers: [],
});

const getters: _GettersTree<IInformer> = {
  getInformers: (state): Informer[] => state.informers,
  getInformerById: (state) => {
    return (_id: string): Informer | null => {
      return state.informers.find((informer) => informer._id === _id) || null;
    };
  },
};

interface InformersActions {
  setInformer(informer: Informer): void;
  removeInformer(id: string): void;
  cleanInformers(): void;
}

const actions: InformersActions = {
  setInformer(this: InformersActions & IInformer, informer: Informer) {
    const index = this.informers.findIndex((item) => item._id === informer._id);

    if (index !== -1) {
      this.informers[index] = { ...this.informers[index], ...informer };
    } else {
      this.informers.push(informer);
    }
  },
  removeInformer(this: InformersActions & IInformer, id: string): void {
    const index = this.informers.findIndex((informer) => informer._id === id);
    if (index !== -1) {
      this.informers.splice(index, 1);
    }
  },
  cleanInformers(this: InformersActions & IInformer): void {
    this.informers = [];
  },
};

export const useInformers: StoreDefinition<
  string,
  IInformer,
  _GettersTree<IInformer>,
  _ActionsTree
> = defineStore<string, IInformer>("informers", {
  state,
  getters,
  actions,
});
